import { TerminalVersionViewDiff } from "src/app/features/TerminalVersion/components/forms/TerminalVersionViewDiff";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const TerminalVersionViewDiffPage = () => {
    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.terminalVersionViewDiffPage" />
                <ActionBar>
                    <CancelButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.TERMINAL_VERSIONS}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <TerminalVersionViewDiff />
            </FPageContent>
        </FPage>
    );
};
